// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* The modal has a fixed height: the title and the buttons stay put, and what
   is between them scrolls. */
.vBKNg_aDEQ1z610XzKBd {
    display: flex;
    flex-direction: column;
    flex: 1;
    min-height: 0;
}

.zth9cmApj62l_5qc9gdO {
    flex: 1;
    min-height: 0;
    overflow-y: auto;
    margin: 0 -28px 12px;
    padding: 0 28px;
}

.uzjR3Co_ADrTdV3Rm81u {
    list-style: none;
    margin: 0 0 16px;
    padding: 0;
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.Z46yg67XGTJHat3SaGwK {
    display: flex;
    flex-direction: column;
    gap: 8px;
    padding: 10px 12px;
    border: 1px solid var(--curio-border-strong);
    border-radius: var(--curio-radius-md);
    background: var(--curio-card-bg);
}

.XdixygUk_40_o4PDh7wg,
.Vnzh8OkqqSOcF4oZ61lZ {
    display: flex;
    align-items: center;
    gap: 8px;
    flex-wrap: wrap;
}

.jKgeryAe_GL47ciRTh2I {
    font-family: var(--curio-font-mono);
    font-weight: 600;
    color: var(--curio-text-primary);
}

.pa1F4T00ucAgXkhUsYtw {
    flex: 1;
    margin: 0;
    font-size: var(--curio-font-size-sm);
    color: var(--curio-text-muted);
    overflow-wrap: anywhere;
}

.v0PCebYH5p8vsCOZUU4S {
    margin-left: auto;
    padding: 6px 10px;
    border: 1px solid var(--curio-border-strong);
    border-radius: var(--curio-radius-md);
    background: var(--curio-card-bg);
    color: var(--curio-text-primary);
    font: inherit;
    font-size: var(--curio-font-size-sm);
}

.P364jl_B0ez4kMVRmM62 {
    margin-bottom: 16px;
}
`, "",{"version":3,"sources":["webpack://./src/components/packages/editing/NodeFromFunctionModal.module.css"],"names":[],"mappings":"AAAA;6BAC6B;AAC7B;IACI,aAAa;IACb,sBAAsB;IACtB,OAAO;IACP,aAAa;AACjB;;AAEA;IACI,OAAO;IACP,aAAa;IACb,gBAAgB;IAChB,oBAAoB;IACpB,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,UAAU;IACV,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,kBAAkB;IAClB,4CAA4C;IAC5C,qCAAqC;IACrC,gCAAgC;AACpC;;AAEA;;IAEI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;AACnB;;AAEA;IACI,mCAAmC;IACnC,gBAAgB;IAChB,gCAAgC;AACpC;;AAEA;IACI,OAAO;IACP,SAAS;IACT,oCAAoC;IACpC,8BAA8B;IAC9B,uBAAuB;AAC3B;;AAEA;IACI,iBAAiB;IACjB,iBAAiB;IACjB,4CAA4C;IAC5C,qCAAqC;IACrC,gCAAgC;IAChC,gCAAgC;IAChC,aAAa;IACb,oCAAoC;AACxC;;AAEA;IACI,mBAAmB;AACvB","sourcesContent":["/* The modal has a fixed height: the title and the buttons stay put, and what\n   is between them scrolls. */\n.dialog {\n    display: flex;\n    flex-direction: column;\n    flex: 1;\n    min-height: 0;\n}\n\n.body {\n    flex: 1;\n    min-height: 0;\n    overflow-y: auto;\n    margin: 0 -28px 12px;\n    padding: 0 28px;\n}\n\n.parameters {\n    list-style: none;\n    margin: 0 0 16px;\n    padding: 0;\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n}\n\n.parameter {\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n    padding: 10px 12px;\n    border: 1px solid var(--curio-border-strong);\n    border-radius: var(--curio-radius-md);\n    background: var(--curio-card-bg);\n}\n\n.parameterHead,\n.parameterBody {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    flex-wrap: wrap;\n}\n\n.parameterName {\n    font-family: var(--curio-font-mono);\n    font-weight: 600;\n    color: var(--curio-text-primary);\n}\n\n.parameterHint {\n    flex: 1;\n    margin: 0;\n    font-size: var(--curio-font-size-sm);\n    color: var(--curio-text-muted);\n    overflow-wrap: anywhere;\n}\n\n.useSelect {\n    margin-left: auto;\n    padding: 6px 10px;\n    border: 1px solid var(--curio-border-strong);\n    border-radius: var(--curio-radius-md);\n    background: var(--curio-card-bg);\n    color: var(--curio-text-primary);\n    font: inherit;\n    font-size: var(--curio-font-size-sm);\n}\n\n.labelInput {\n    margin-bottom: 16px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dialog": `vBKNg_aDEQ1z610XzKBd`,
	"body": `zth9cmApj62l_5qc9gdO`,
	"parameters": `uzjR3Co_ADrTdV3Rm81u`,
	"parameter": `Z46yg67XGTJHat3SaGwK`,
	"parameterHead": `XdixygUk_40_o4PDh7wg`,
	"parameterBody": `Vnzh8OkqqSOcF4oZ61lZ`,
	"parameterName": `jKgeryAe_GL47ciRTh2I`,
	"parameterHint": `pa1F4T00ucAgXkhUsYtw`,
	"useSelect": `v0PCebYH5p8vsCOZUU4S`,
	"labelInput": `P364jl_B0ez4kMVRmM62`
};
export default ___CSS_LOADER_EXPORT___;
